/**
 * Consent Mode / GTM (optional GTM_ID).
 */

export function hasAnalyticsConsentFromCookie() {
	const match = document.cookie.match(/(?:^|;\s*)cc_cookie=([^;]*)/);
	if (!match) return false;
	try {
		const cookie = JSON.parse(decodeURIComponent(match[1]));
		return Array.isArray(cookie?.categories) && cookie.categories.includes('analytics');
	} catch {
		return false;
	}
}

export function hasAnalyticsConsent() {
	if (typeof window.CookieConsent?.acceptedCategory === 'function') {
		return window.CookieConsent.acceptedCategory('analytics');
	}
	return hasAnalyticsConsentFromCookie();
}

export function getGtmId() {
	const id = window.JWP?.gtmId;
	return typeof id === 'string' && /^GTM-[A-Z0-9]+$/i.test(id) ? id : '';
}

/** Load gtm.js once when analytics consent + GTM ID are present. */
export function loadGtmWhenAllowed() {
	if (!hasAnalyticsConsent()) return false;
	const gtmId = getGtmId();
	if (!gtmId) return false;
	if (window.__mtstGtmLoaded) return true;

	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

	const script = document.createElement('script');
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(gtmId)}`;
	document.head.appendChild(script);
	window.__mtstGtmLoaded = true;
	return true;
}

export function pushGoogleConsentUpdate(analyticsGranted) {
	window.dataLayer = window.dataLayer || [];
	window.gtag =
		window.gtag ||
		function gtag() {
			window.dataLayer.push(arguments);
		};

	const state = analyticsGranted ? 'granted' : 'denied';

	gtag('consent', 'update', {
		analytics_storage: state,
		ad_storage: state,
		ad_user_data: state,
		ad_personalization: state,
	});

	window.dataLayer.push({
		event: analyticsGranted ? 'consent_analytics_granted' : 'consent_analytics_denied',
		analytics_storage: state,
	});

	if (analyticsGranted) {
		loadGtmWhenAllowed();
	}
}
